export const buyDiscountCardScope = 'app.containers.buyDiscountCard';

export const buyDiscountCardMessages = {
  title: {
    id: `${buyDiscountCardScope}.title`,
    defaultMessage: 'Achetez ou renouvelez votre carte avantage',
    en: 'Buy or renew your advantage card',
    es: 'Compra o renueva tu tarjeta de ventaja',
    it: 'Acquista o rinnova la tua carta vantaggi',
    de: 'Kaufen oder verlängern Sie Ihre Vorteilskarte',
    nl: 'Koop of verleng uw voordeelkaart',
  },
  subtitle: {
    id: `${buyDiscountCardScope}.subtitle`,
    defaultMessage:
      "Deux minutes chrono pour économiser jusqu'à 30 % sur vos trajets en train. Nous émettons votre carte auprès de la SNCF, au même prix.",
    en: 'Two minutes to save up to 30% on your train trips. We issue your card with SNCF, at the same price.',
    es: 'Dos minutos para ahorrar hasta un 30 % en tus viajes en tren. Emitimos tu tarjeta con la SNCF, al mismo precio.',
    it: 'Due minuti per risparmiare fino al 30% sui tuoi viaggi in treno. Emettiamo la tua carta con SNCF, allo stesso prezzo.',
    de: 'Zwei Minuten, um bis zu 30 % bei Ihren Zugreisen zu sparen. Wir stellen Ihre Karte bei der SNCF aus, zum gleichen Preis.',
    nl: 'Twee minuten om tot 30% te besparen op uw treinreizen. Wij geven uw kaart uit bij SNCF, tegen dezelfde prijs.',
  },
  notSure: {
    id: `${buyDiscountCardScope}.notSure`,
    defaultMessage:
      'Vous ne savez pas quelle carte choisir ? Notre service client vous conseille.',
    en: 'Not sure which card to choose? Our customer service will advise you.',
    es: '¿No sabes qué tarjeta elegir? Nuestro servicio de atención al cliente te asesora.',
    it: 'Non sai quale carta scegliere? Il nostro servizio clienti ti consiglia.',
    de: 'Sie wissen nicht, welche Karte Sie wählen sollen? Unser Kundenservice berät Sie.',
    nl: 'Weet u niet welke kaart u moet kiezen? Onze klantenservice adviseert u.',
  },
  cardSection: {
    id: `${buyDiscountCardScope}.cardSection`,
    defaultMessage: 'Votre carte',
    en: 'Your card',
    es: 'Tu tarjeta',
    it: 'La tua carta',
    de: 'Ihre Karte',
    nl: 'Uw kaart',
  },
  AVANTAGE_JEUNE: {
    id: `${buyDiscountCardScope}.AVANTAGE_JEUNE`,
    defaultMessage: '-30 % sur vos trajets et -60 % pour 3 enfants',
    en: '-30% on your trips and -60% for 3 children',
    es: '-30 % en tus viajes y -60 % para 3 niños',
    it: '-30% sui tuoi viaggi e -60% per 3 bambini',
    de: '-30 % auf Ihre Reisen und -60 % für 3 Kinder',
    nl: '-30% op uw reizen en -60% voor 3 kinderen',
  },
  AVANTAGE_ADULTE: {
    id: `${buyDiscountCardScope}.AVANTAGE_ADULTE`,
    defaultMessage: '-30 % pour vous et un accompagnant, -60 % pour 3 enfants',
    en: '-30% for you and a companion, -60% for 3 children',
    es: '-30 % para ti y un acompañante, -60 % para 3 niños',
    it: '-30% per te e un accompagnatore, -60% per 3 bambini',
    de: '-30 % für Sie und eine Begleitperson, -60 % für 3 Kinder',
    nl: '-30% voor u en een begeleider, -60% voor 3 kinderen',
  },
  AVANTAGE_SENIOR: {
    id: `${buyDiscountCardScope}.AVANTAGE_SENIOR`,
    defaultMessage: '-30 % sur vos trajets et -60 % pour 3 enfants',
    en: '-30% on your trips and -60% for 3 children',
    es: '-30 % en tus viajes y -60 % para 3 niños',
    it: '-30% sui tuoi viaggi e -60% per 3 bambini',
    de: '-30 % auf Ihre Reisen und -60 % für 3 Kinder',
    nl: '-30% op uw reizen en -60% voor 3 kinderen',
  },
  LIBERTE: {
    id: `${buyDiscountCardScope}.LIBERTE`,
    defaultMessage:
      'Tarifs fixes pour vos trajets pros (-60 % en Business Première) et -30 % sur vos trajets persos',
    en: 'Fixed fares for business trips (-60% in Business Première) and -30% on personal trips',
    es: 'Tarifas fijas para tus viajes de negocios (-60 % en Business Première) y -30 % en tus viajes personales',
    it: 'Tariffe fisse per i viaggi di lavoro (-60% in Business Première) e -30% sui viaggi personali',
    de: 'Festpreise für Geschäftsreisen (-60 % in der Business Première) und -30 % auf private Reisen',
    nl: 'Vaste tarieven voor zakenreizen (-60% in Business Première) en -30% op privéreizen',
  },
  validityStartDate: {
    id: `${buyDiscountCardScope}.validityStartDate`,
    defaultMessage: 'Début de validité',
    en: 'Start of validity',
    es: 'Inicio de validez',
    it: 'Inizio validità',
    de: 'Gültigkeitsbeginn',
    nl: 'Begin geldigheid',
  },
  cardToRenewNumber: {
    id: `${buyDiscountCardScope}.cardToRenewNumber`,
    defaultMessage: 'Numéro de la carte à renouveler',
    en: 'Number of the card to renew',
    es: 'Número de la tarjeta a renovar',
    it: 'Numero della carta da rinnovare',
    de: 'Nummer der zu verlängernden Karte',
    nl: 'Nummer van de te verlengen kaart',
  },
  loyaltyCardNumber: {
    id: `${buyDiscountCardScope}.loyaltyCardNumber`,
    defaultMessage: 'N° de fidélité SNCF (facultatif)',
    en: 'SNCF loyalty card number (optional)',
    es: 'Número de tarjeta de fidelidad SNCF (opcional)',
    it: 'Numero della carta fedeltà SNCF (facoltativo)',
    de: 'SNCF-Treuekartennummer (optional)',
    nl: 'SNCF-klantenkaartnummer (optioneel)',
  },
  holderSection: {
    id: `${buyDiscountCardScope}.holderSection`,
    defaultMessage: 'Titulaire de la carte',
    en: 'Card holder',
    es: 'Titular de la tarjeta',
    it: 'Titolare della carta',
    de: 'Karteninhaber',
    nl: 'Kaarthouder',
  },
  MS: {
    id: `${buyDiscountCardScope}.MS`,
    defaultMessage: 'Madame',
    en: 'Mrs',
    es: 'Señora',
    it: 'Signora',
    de: 'Frau',
    nl: 'Mevrouw',
  },
  MR: {
    id: `${buyDiscountCardScope}.MR`,
    defaultMessage: 'Monsieur',
    en: 'Mr',
    es: 'Señor',
    it: 'Signore',
    de: 'Herr',
    nl: 'Meneer',
  },
  firstName: {
    id: `${buyDiscountCardScope}.firstName`,
    defaultMessage: 'Prénom',
    en: 'First name',
    es: 'Nombre',
    it: 'Nome',
    de: 'Vorname',
    nl: 'Voornaam',
  },
  lastName: {
    id: `${buyDiscountCardScope}.lastName`,
    defaultMessage: 'Nom',
    en: 'Last name',
    es: 'Apellido',
    it: 'Cognome',
    de: 'Nachname',
    nl: 'Achternaam',
  },
  birthdate: {
    id: `${buyDiscountCardScope}.birthdate`,
    defaultMessage: 'Date de naissance',
    en: 'Date of birth',
    es: 'Fecha de nacimiento',
    it: 'Data di nascita',
    de: 'Geburtsdatum',
    nl: 'Geboortedatum',
  },
  email: {
    id: `${buyDiscountCardScope}.email`,
    defaultMessage: 'E-mail',
    en: 'Email',
    es: 'Correo electrónico',
    it: 'E-mail',
    de: 'E-Mail',
    nl: 'E-mail',
  },
  phone: {
    id: `${buyDiscountCardScope}.phone`,
    defaultMessage: 'Téléphone',
    en: 'Phone',
    es: 'Teléfono',
    it: 'Telefono',
    de: 'Telefon',
    nl: 'Telefoon',
  },
  addressSection: {
    id: `${buyDiscountCardScope}.addressSection`,
    defaultMessage: 'Adresse postale (demandée par la SNCF)',
    en: 'Postal address (required by SNCF)',
    es: 'Dirección postal (exigida por la SNCF)',
    it: 'Indirizzo postale (richiesto da SNCF)',
    de: 'Postanschrift (von der SNCF verlangt)',
    nl: 'Postadres (vereist door SNCF)',
  },
  street: {
    id: `${buyDiscountCardScope}.street`,
    defaultMessage: 'N° et nom de la voie',
    en: 'Street address',
    es: 'Número y nombre de la calle',
    it: 'Numero e nome della via',
    de: 'Straße und Hausnummer',
    nl: 'Straat en huisnummer',
  },
  zipCode: {
    id: `${buyDiscountCardScope}.zipCode`,
    defaultMessage: 'Code postal',
    en: 'Postcode',
    es: 'Código postal',
    it: 'CAP',
    de: 'Postleitzahl',
    nl: 'Postcode',
  },
  city: {
    id: `${buyDiscountCardScope}.city`,
    defaultMessage: 'Ville',
    en: 'City',
    es: 'Ciudad',
    it: 'Città',
    de: 'Stadt',
    nl: 'Plaats',
  },
  country: {
    id: `${buyDiscountCardScope}.country`,
    defaultMessage: 'Pays',
    en: 'Country',
    es: 'País',
    it: 'Paese',
    de: 'Land',
    nl: 'Land',
  },
  pay: {
    id: `${buyDiscountCardScope}.pay`,
    defaultMessage: 'Payer {price}',
    en: 'Pay {price}',
    es: 'Pagar {price}',
    it: 'Paga {price}',
    de: '{price} bezahlen',
    nl: '{price} betalen',
  },
  waitConfirmation: {
    id: `${buyDiscountCardScope}.waitConfirmation`,
    defaultMessage: 'Paiement en cours de validation…',
    en: 'Validating your payment…',
    es: 'Validando tu pago…',
    it: 'Convalida del pagamento in corso…',
    de: 'Ihre Zahlung wird geprüft…',
    nl: 'Uw betaling wordt gecontroleerd…',
  },
  successTitle: {
    id: `${buyDiscountCardScope}.successTitle`,
    defaultMessage: 'Merci, votre commande est confirmée !',
    en: 'Thank you, your order is confirmed!',
    es: '¡Gracias, tu pedido está confirmado!',
    it: 'Grazie, il tuo ordine è confermato!',
    de: 'Vielen Dank, Ihre Bestellung ist bestätigt!',
    nl: 'Bedankt, uw bestelling is bevestigd!',
  },
  successText: {
    id: `${buyDiscountCardScope}.successText`,
    defaultMessage:
      'Nous vous envoyons votre carte avantage par e-mail dans les prochaines heures. Un e-mail de confirmation vient de partir.',
    en: 'We will send your advantage card by email within the next few hours. A confirmation email is on its way.',
    es: 'Te enviaremos tu tarjeta de ventaja por correo electrónico en las próximas horas. Te hemos enviado un correo de confirmación.',
    it: 'Ti invieremo la tua carta vantaggi via e-mail nelle prossime ore. Ti abbiamo inviato un’e-mail di conferma.',
    de: 'Wir senden Ihnen Ihre Vorteilskarte in den nächsten Stunden per E-Mail. Eine Bestätigungs-E-Mail ist unterwegs.',
    nl: 'We sturen u uw voordeelkaart binnen enkele uren per e-mail. Er is een bevestigingsmail naar u onderweg.',
  },
  paymentFailed: {
    id: `${buyDiscountCardScope}.paymentFailed`,
    defaultMessage: "Le paiement n'a pas abouti. Vous pouvez réessayer.",
    en: 'The payment did not go through. You can try again.',
    es: 'El pago no se ha realizado. Puedes intentarlo de nuevo.',
    it: 'Il pagamento non è andato a buon fine. Puoi riprovare.',
    de: 'Die Zahlung ist fehlgeschlagen. Sie können es erneut versuchen.',
    nl: 'De betaling is mislukt. U kunt het opnieuw proberen.',
  },
  genericError: {
    id: `${buyDiscountCardScope}.genericError`,
    defaultMessage:
      'Une erreur est survenue. Vérifiez vos informations puis réessayez.',
    en: 'Something went wrong. Check your details and try again.',
    es: 'Se ha producido un error. Comprueba tus datos e inténtalo de nuevo.',
    it: 'Si è verificato un errore. Controlla i tuoi dati e riprova.',
    de: 'Ein Fehler ist aufgetreten. Prüfen Sie Ihre Angaben und versuchen Sie es erneut.',
    nl: 'Er is iets misgegaan. Controleer uw gegevens en probeer het opnieuw.',
  },
  requiredField: {
    id: `${buyDiscountCardScope}.requiredField`,
    defaultMessage: 'Champ obligatoire',
    en: 'Required field',
    es: 'Campo obligatorio',
    it: 'Campo obbligatorio',
    de: 'Pflichtfeld',
    nl: 'Verplicht veld',
  },
  invalidDate: {
    id: `${buyDiscountCardScope}.invalidDate`,
    defaultMessage: 'Date invalide (JJ/MM/AAAA)',
    en: 'Invalid date (DD/MM/YYYY)',
    es: 'Fecha no válida (DD/MM/AAAA)',
    it: 'Data non valida (GG/MM/AAAA)',
    de: 'Ungültiges Datum (TT/MM/JJJJ)',
    nl: 'Ongeldige datum (DD/MM/JJJJ)',
  },
  startDateInPast: {
    id: `${buyDiscountCardScope}.startDateInPast`,
    defaultMessage: 'La carte ne peut pas commencer dans le passé',
    en: 'The card cannot start in the past',
    es: 'La tarjeta no puede empezar en el pasado',
    it: 'La carta non può iniziare nel passato',
    de: 'Die Karte kann nicht in der Vergangenheit beginnen',
    nl: 'De kaart kan niet in het verleden beginnen',
  },
  startDateTooLate: {
    id: `${buyDiscountCardScope}.startDateTooLate`,
    defaultMessage: 'La carte doit commencer dans les 6 mois',
    en: 'The card must start within 6 months',
    es: 'La tarjeta debe empezar en los próximos 6 meses',
    it: 'La carta deve iniziare entro 6 mesi',
    de: 'Die Karte muss innerhalb von 6 Monaten beginnen',
    nl: 'De kaart moet binnen 6 maanden ingaan',
  },
  invalidAgeForCard: {
    id: `${buyDiscountCardScope}.invalidAgeForCard`,
    defaultMessage: "L'âge du titulaire ne correspond pas à cette carte",
    en: "The holder's age does not match this card",
    es: 'La edad del titular no corresponde a esta tarjeta',
    it: "L'età del titolare non corrisponde a questa carta",
    de: 'Das Alter des Inhabers passt nicht zu dieser Karte',
    nl: 'De leeftijd van de houder past niet bij deze kaart',
  },
  invalidCardNumber: {
    id: `${buyDiscountCardScope}.invalidCardNumber`,
    defaultMessage: 'Numéro de carte invalide',
    en: 'Invalid card number',
    es: 'Número de tarjeta no válido',
    it: 'Numero di carta non valido',
    de: 'Ungültige Kartennummer',
    nl: 'Ongeldig kaartnummer',
  },
  invalidPhone: {
    id: `${buyDiscountCardScope}.invalidPhone`,
    defaultMessage: 'Numéro de téléphone invalide',
    en: 'Invalid phone number',
    es: 'Número de teléfono no válido',
    it: 'Numero di telefono non valido',
    de: 'Ungültige Telefonnummer',
    nl: 'Ongeldig telefoonnummer',
  },
  invalidEmail: {
    id: `${buyDiscountCardScope}.invalidEmail`,
    defaultMessage: 'E-mail invalide',
    en: 'Invalid email',
    es: 'Correo electrónico no válido',
    it: 'E-mail non valida',
    de: 'Ungültige E-Mail',
    nl: 'Ongeldig e-mailadres',
  },
  stepCARD: {
    id: `${buyDiscountCardScope}.stepCARD`,
    defaultMessage: 'Carte',
    en: 'Card',
    es: 'Tarjeta',
    it: 'Carta',
    de: 'Karte',
    nl: 'Kaart',
  },
  stepPAYMENT: {
    id: `${buyDiscountCardScope}.stepPAYMENT`,
    defaultMessage: 'Paiement',
    en: 'Payment',
    es: 'Pago',
    it: 'Pagamento',
    de: 'Zahlung',
    nl: 'Betaling',
  },
  stepOf: {
    id: `${buyDiscountCardScope}.stepOf`,
    defaultMessage: 'Étape {current} sur {total}',
    en: 'Step {current} of {total}',
    es: 'Paso {current} de {total}',
    it: 'Passo {current} di {total}',
    de: 'Schritt {current} von {total}',
    nl: 'Stap {current} van {total}',
  },
  continue: {
    id: `${buyDiscountCardScope}.continue`,
    defaultMessage: 'Continuer',
    en: 'Continue',
    es: 'Continuar',
    it: 'Continua',
    de: 'Weiter',
    nl: 'Doorgaan',
  },
  back: {
    id: `${buyDiscountCardScope}.back`,
    defaultMessage: 'Retour',
    en: 'Back',
    es: 'Volver',
    it: 'Indietro',
    de: 'Zurück',
    nl: 'Terug',
  },
  edit: {
    id: `${buyDiscountCardScope}.edit`,
    defaultMessage: 'Modifier',
    en: 'Edit',
    es: 'Modificar',
    it: 'Modifica',
    de: 'Ändern',
    nl: 'Wijzigen',
  },
  recapTitle: {
    id: `${buyDiscountCardScope}.recapTitle`,
    defaultMessage: 'Vérifiez avant de payer',
    en: 'Check before paying',
    es: 'Comprueba antes de pagar',
    it: 'Controlla prima di pagare',
    de: 'Vor dem Bezahlen prüfen',
    nl: 'Controleer voor u betaalt',
  },
  recapCard: {
    id: `${buyDiscountCardScope}.recapCard`,
    defaultMessage: 'Carte',
    en: 'Card',
    es: 'Tarjeta',
    it: 'Carta',
    de: 'Karte',
    nl: 'Kaart',
  },
  recapValidity: {
    id: `${buyDiscountCardScope}.recapValidity`,
    defaultMessage: 'Validité',
    en: 'Validity',
    es: 'Validez',
    it: 'Validità',
    de: 'Gültigkeit',
    nl: 'Geldigheid',
  },
  recapValidityDates: {
    id: `${buyDiscountCardScope}.recapValidityDates`,
    defaultMessage: 'Du {start} au {end}',
    en: 'From {start} to {end}',
    es: 'Del {start} al {end}',
    it: 'Dal {start} al {end}',
    de: 'Vom {start} bis {end}',
    nl: 'Van {start} tot {end}',
  },
  recapRenewedCard: {
    id: `${buyDiscountCardScope}.recapRenewedCard`,
    defaultMessage: 'Carte renouvelée',
    en: 'Renewed card',
    es: 'Tarjeta renovada',
    it: 'Carta rinnovata',
    de: 'Verlängerte Karte',
    nl: 'Verlengde kaart',
  },
  recapHolder: {
    id: `${buyDiscountCardScope}.recapHolder`,
    defaultMessage: 'Titulaire',
    en: 'Holder',
    es: 'Titular',
    it: 'Titolare',
    de: 'Inhaber',
    nl: 'Houder',
  },
  recapEmail: {
    id: `${buyDiscountCardScope}.recapEmail`,
    defaultMessage: 'E-mail',
    en: 'Email',
    es: 'Correo electrónico',
    it: 'E-mail',
    de: 'E-Mail',
    nl: 'E-mail',
  },
  recapAddress: {
    id: `${buyDiscountCardScope}.recapAddress`,
    defaultMessage: 'Adresse',
    en: 'Address',
    es: 'Dirección',
    it: 'Indirizzo',
    de: 'Adresse',
    nl: 'Adres',
  },
  orderTitle: {
    id: `${buyDiscountCardScope}.orderTitle`,
    defaultMessage: 'Votre commande',
    en: 'Your order',
    es: 'Tu pedido',
    it: 'Il tuo ordine',
    de: 'Ihre Bestellung',
    nl: 'Uw bestelling',
  },
  oneYear: {
    id: `${buyDiscountCardScope}.oneYear`,
    defaultMessage: '1 an',
    en: '1 year',
    es: '1 año',
    it: '1 anno',
    de: '1 Jahr',
    nl: '1 jaar',
  },
  fees: {
    id: `${buyDiscountCardScope}.fees`,
    defaultMessage: 'Frais Tictactrip',
    en: 'Tictactrip fees',
    es: 'Gastos Tictactrip',
    it: 'Commissioni Tictactrip',
    de: 'Tictactrip-Gebühren',
    nl: 'Tictactrip-kosten',
  },
  total: {
    id: `${buyDiscountCardScope}.total`,
    defaultMessage: 'Total',
    en: 'Total',
    es: 'Total',
    it: 'Totale',
    de: 'Gesamt',
    nl: 'Totaal',
  },
  samePrice: {
    id: `${buyDiscountCardScope}.samePrice`,
    defaultMessage: 'Même prix que la SNCF',
    en: 'Same price as SNCF',
    es: 'Mismo precio que la SNCF',
    it: 'Stesso prezzo di SNCF',
    de: 'Gleicher Preis wie bei der SNCF',
    nl: 'Zelfde prijs als bij SNCF',
  },
  deliveredIn24h: {
    id: `${buyDiscountCardScope}.deliveredIn24h`,
    defaultMessage: 'Reçue par e-mail sous 24 h',
    en: 'Received by email within 24 h',
    es: 'Recibida por correo en 24 h',
    it: 'Ricevuta via e-mail entro 24 h',
    de: 'Per E-Mail innerhalb von 24 Std.',
    nl: 'Binnen 24 uur per e-mail',
  },
  securePayment: {
    id: `${buyDiscountCardScope}.securePayment`,
    defaultMessage: 'Paiement sécurisé par Payline',
    en: 'Secure payment with Payline',
    es: 'Pago seguro con Payline',
    it: 'Pagamento sicuro con Payline',
    de: 'Sichere Zahlung mit Payline',
    nl: 'Veilig betalen met Payline',
  },
  ages: {
    id: `${buyDiscountCardScope}.ages`,
    defaultMessage: '{min}-{max} ans',
    en: '{min}-{max} years',
    es: '{min}-{max} años',
    it: '{min}-{max} anni',
    de: '{min}-{max} Jahre',
    nl: '{min}-{max} jaar',
  },
  agesFrom: {
    id: `${buyDiscountCardScope}.agesFrom`,
    defaultMessage: '{min} ans et plus',
    en: '{min} and over',
    es: '{min} años o más',
    it: '{min} anni e oltre',
    de: 'Ab {min} Jahren',
    nl: '{min} jaar en ouder',
  },
  noAgeLimit: {
    id: `${buyDiscountCardScope}.noAgeLimit`,
    defaultMessage: "Sans limite d'âge",
    en: 'No age limit',
    es: 'Sin límite de edad',
    it: 'Senza limiti di età',
    de: 'Ohne Altersgrenze',
    nl: 'Geen leeftijdsgrens',
  },
  offersError: {
    id: `${buyDiscountCardScope}.offersError`,
    defaultMessage: "Les cartes n'ont pas pu être chargées.",
    en: 'The cards could not be loaded.',
    es: 'No se han podido cargar las tarjetas.',
    it: 'Non è stato possibile caricare le carte.',
    de: 'Die Karten konnten nicht geladen werden.',
    nl: 'De kaarten konden niet worden geladen.',
  },
  retry: {
    id: `${buyDiscountCardScope}.retry`,
    defaultMessage: 'Réessayer',
    en: 'Try again',
    es: 'Reintentar',
    it: 'Riprova',
    de: 'Erneut versuchen',
    nl: 'Opnieuw proberen',
  },
  stepINFO: {
    id: `${buyDiscountCardScope}.stepINFO`,
    defaultMessage: 'Vos infos',
    en: 'Your details',
    es: 'Tus datos',
    it: 'I tuoi dati',
    de: 'Ihre Angaben',
    nl: 'Uw gegevens',
  },
  renewCard: {
    id: `${buyDiscountCardScope}.renewCard`,
    defaultMessage: 'Je renouvelle ma carte',
    en: 'I am renewing my card',
    es: 'Renuevo mi tarjeta',
    it: 'Rinnovo la mia carta',
    de: 'Ich verlängere meine Karte',
    nl: 'Ik verleng mijn kaart',
  },
  offerSwitched: {
    id: `${buyDiscountCardScope}.offerSwitched`,
    defaultMessage:
      "Nous avons choisi la {label}, adaptée à l'âge du titulaire au début de validité.",
    en: 'We picked the {label}, which fits the holder age on the first day of the card.',
    es: 'Hemos elegido la {label}, adaptada a la edad del titular al inicio de la validez.',
    it: "Abbiamo scelto la {label}, adatta all'età del titolare all'inizio della validità.",
    de: 'Wir haben die {label} gewählt, passend zum Alter des Inhabers bei Gültigkeitsbeginn.',
    nl: 'We hebben de {label} gekozen, passend bij de leeftijd van de houder bij het begin van de geldigheid.',
  },
};
